// extracted by mini-css-extract-plugin
export var phone = "_3y-0";
export var phoneDragging = "_3y-1";